import { API } from '@/BeatoutAPI';
export default {
    async updatePackages(_context) {
        await API.getRequest().put('software/update-packages');
    },
    async updateSoftware(_context, params) {
        await API.getRequest().put(`software/${params.service}=${params.version}`);
    }
};
